module.exports = __webpack_public_path__ + "0d67b92a2407fb5889b11e77e25fb786.png";